import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";

function AlertDialog({
  open,
  setOpen,
  action,
  setAction,
  labelAction,
  colorAction,
  children,
  onCancel,
}) {
  function handleCancel() {
    onCancel();
    setOpen(false);
  }
  return (
    <React.Fragment>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={"xs"}
        sx={{
          borderRadius: "30px",
        }}
      >
        <DialogContent
          sx={{
            margin: "0px",
            padding: "10px",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              color: "darkgray",
            }}
            onClick={() => {
              handleCancel();
            }}
            disabled={action}
          >
            Annuler
          </Button>
          <Button
            color={colorAction}
            variant="contained"
            disabled={action}
            disableElevation
            onClick={() => setAction(true)}
          >
            <span>{labelAction}</span>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
export default AlertDialog;
